  // Import the functions you need from the SDKs you need
  import { initializeApp } from "firebase/app";
  import { getFirestore } from "firebase/firestore";
  import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries


const firebaseConfig = {
  apiKey: "AIzaSyDQ1dWRGo--7ZdnK-NrV7tHNZwbJMVBmT0",
  authDomain: "umirg-d03b7.firebaseapp.com",
  projectId: "umirg-d03b7",
  storageBucket: "umirg-d03b7.firebasestorage.app",
  messagingSenderId: "993962877209",
  appId: "1:993962877209:web:4324b3d120c061a0ad6588",
  measurementId: "G-GE111FQNEN"
};

// Initialize Firebase

const app = initializeApp(firebaseConfig);
// Export firestore database
// It will be imported into your react app whenever it is needed
export const db = getFirestore(app);
export const storage = getStorage(app);
